import {
    Component,
    input,
    computed,
    ChangeDetectionStrategy,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgIcon } from '@ng-icons/core'
import { navigationGroups as defaultNavigationGroups } from './sidebar.data'
import { NavigationGroup } from './sidebar.model'

@Component({
    selector: 'app-sidebar-admin-default',
    imports: [RouterModule, NgIcon],
    templateUrl: './sidebar-admin-default.component.html',
    styleUrl: './sidebar-admin-default.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarAdminDefaultComponent {
    isCollapsed = input(false)
    logoSrc = input('assets/images/logo_vendor.png')
    logoSrcCollapsed = input('')
    logoAlt = input('Full Logo')
    navigationGroups = input<NavigationGroup[]>(defaultNavigationGroups)

    showLabel = computed(() => !this.isCollapsed())

    currentLogoSrc = computed(() => {
        return this.isCollapsed() && this.logoSrcCollapsed()
            ? this.logoSrcCollapsed()
            : this.logoSrc()
    })
}
